import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import { useAppSelector } from "../redux/hooks";
import UserContextHook from "hooks/userContext-hook";

export const Navbar = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const todoListCount: any = useAppSelector(
    (state) => state.updateTodoListCount.data
  );
  const userContext = UserContextHook();
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigateRoutes = (navValue: string) => {
    switch (navValue) {
      case "Appraisal":
        return navigate("/main/appraisal-form/new");
      case "Debt Liability":
        return navigate("/main/debt-liability/new");
      case "Global Equity":
        return navigate("/global/global-equity/new");
      default:
        return navigate("/main/appraisal-form");
    }
  };

  const path = window.location.pathname;
  const highlightedCss = !path.startsWith("/dashboard")
    ? "dropbtn-selected dropbtn"
    : "dropbtn";

  const shouldButtonVisible = (buttonName: string) => {
    var flag: boolean = false;
    switch (buttonName) {
      case "Appraisal":
        if ((userContext?.isAdmin || userContext?.isAppraisal1) && userContext?.isUS) {
          flag = true;
        } else {
          flag = false;
        }
        break;
      case "Debt Liability":
        if ((userContext?.isAdmin || userContext?.isDebtAppraisal1) && userContext?.isUS) {
          flag = true;
        } else {
          flag = false;
        }
        break;
      case "Global Equity":
        if ((userContext?.isAdmin || userContext?.isAppraisal1) && (userContext?.isEMEA || userContext?.isAPAC)) {
          flag = true;
        } else {
          flag = false;
        }
        break;
    }

    return flag;
  }

  return (
    <Container maxWidth={false} className="navbar">
      <Box>
        {(userContext?.isEMEA || userContext?.isAPAC) && <NavLink to="/global/dashboard">Global Dashboard</NavLink>}
        {userContext?.isUS && <NavLink to="/main/dashboard">US Dashboard</NavLink>}

        <div className="dropdown">
          {userContext?.isAdmin &&
            <Button
              variant="text"
              className="dropbtn"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              // onTouchMove={}
              sx={{ color: '#333', fontFamily: 'inherit', fontSize: 'inherit', textTransform: 'none', lineHeight: 'inherit' }}
            >
              Settings
            </Button>}{userContext?.isAdmin &&
              <Menu
                id="basic-menu"
                className={highlightedCss}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={() => { navigate("/funds/list"); handleClose(); }}>Funds</MenuItem>
                <MenuItem onClick={() => { navigate("/role/list"); handleClose(); }}>Roles</MenuItem>
                <MenuItem onClick={() => { navigate("/fundconfig/list"); handleClose(); }}>Fund Configuration</MenuItem>
                <MenuItem onClick={() => { navigate("/investmentmaster/list"); handleClose(); }}>Investment</MenuItem>
                <MenuItem onClick={() => { navigate("/appraiserfirm/list"); handleClose(); }}>Appraiser Firm</MenuItem>
                <MenuItem onClick={() => { navigate("/userrolemap/list"); handleClose(); }}>User Role Map</MenuItem>
              </Menu>
          }
          {/* <div className="dropdown-content">
            <NavLink to="/funds/list">Funds</NavLink>
            <NavLink to="/role/list">Roles</NavLink>
            <NavLink to="/userrolemap/list">User Role Map</NavLink>
            <NavLink to="/fundconfig/list">Fund Configuration</NavLink>
            <NavLink to="/investmentmaster/list">Investment</NavLink>
            <NavLink to="/investmentmaster/list">Investment</NavLink>
          </div>*/}
        </div>
        <a
          href="https://nre.ams-helpdesk.apps.nuveen.com/auth/saml?idp=nuveen-ams-prod&destination=/app/nra-ams-dashboards%23/display/692e8588f20cd75654092e56"
          target="_blank"
          rel="noopener noreferrer"
          style={{ cursor: 'pointer' }}
        >
          Support
        </a>
        {/* <Badge badgeContent={todoListCount} color="secondary">
          <NavLink to="/todo/list">To-Do's</NavLink>
        </Badge> */}

        <Stack
          direction="row"
          spacing={2}
          className="text-right header-action-btn"
        >
          {shouldButtonVisible("Global Equity") && <Button
            variant="contained"
            color="success"
            sx={{textTransform:"none"}}
            onClick={() => navigateRoutes("Global Equity")}
          >
            <AddIcon /> Global Equity
          </Button>}
          {shouldButtonVisible("Debt Liability") && <Button
            variant="contained"
            color="success"
            sx={{textTransform:"none"}}
            onClick={() => navigateRoutes("Debt Liability")}
          >
            <AddIcon /> Debt Liability
          </Button>}
          {shouldButtonVisible("Appraisal") && <Button
            variant="contained"
            color="success"
            sx={{textTransform:"none"}}
            onClick={() => navigateRoutes("Appraisal")}
          >
            <AddIcon />
            Appraisal
          </Button>}
        </Stack>
      </Box>
    </Container>
  );
};
